import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import './header-buttons.scss';
import { FormattedTag, RouteLink } from 'core/components';
import { TopBarContext } from 'hocs/with-top-bar';
import { IconClose } from 'components/icons/icon-close/icon-close';
import colors from 'customizations/js/color-variables';
import { FormattedMessage } from 'react-intl';
import Button from 'reactstrap/lib/Button';

const HeaderButtonsUI = ({
  onGetBonus, id, minAmount
}) => {
  const { closeRegistrationBonus } = useContext(TopBarContext);

  return (
    <div className="d-flex align-items-center">
      <FormattedTag
        id="gifts.registration.not-now"
        role="button"
        className="btn p-0 d-sm-none w-50 text-white"
        onClick={closeRegistrationBonus}
      />

      <Button
        tag={RouteLink}
        to="/wallet"
        onClick={onGetBonus}
        data-id={id}
        data-min-amount={minAmount}
        className="px-2 d-sm-none text-primary w-50"
        color="white"
      >
        <FormattedMessage id="gifts.registration.claim" />
      </Button>

      <Button
        tag={RouteLink}
        to="/wallet"
        onClick={onGetBonus}
        data-id={id}
        data-min-amount={minAmount}
        className="px-2 d-none d-sm-block text-primary"
        color="white"
      >
        <FormattedMessage id="gifts.registration.claim" />
      </Button>

      <div
        role="button"
        tabIndex={0}
        onClick={closeRegistrationBonus}
        onKeyPress={closeRegistrationBonus}
        className="d-none d-sm-inline ml-md-3 ml-lg-4_5 cursor-pointer mr-1_75"
      >
        <IconClose color={colors.white} />
      </div>
    </div>
  );
};

HeaderButtonsUI.propTypes = {
  id: PropTypes.string,
  onGetBonus: PropTypes.func.isRequired,
  minAmount: PropTypes.string.isRequired,
};

HeaderButtonsUI.defaultProps = {
  id: '',
};

export const HeaderButtons = HeaderButtonsUI;
